// services/SpacesApi.js
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_SPACES_API;
const WALK_IN_VISIT_URL = process.env.REACT_APP_WALK_IN_VISIT;
const CLASS_VISIT_URL = process.env.REACT_APP_CLASS_VISIT;

export const fetchSpacesData = async (fromDate, toDate) => {
  try {
    const url = `${BASE_URL}fromDate=${fromDate}&toDate=${toDate}`;
    console.log(url);
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching spaces data:', error);
    throw error;
  }
};

export const fetchVisitData = async (fromDate, toDate) => {
  try {
    const url = `${process.env.REACT_APP_VISIT_SUMMARY_API}startDate=${fromDate}&endDate=${toDate}`;
    console.log(url);
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching spaces data:', error);
    throw error;
  }
};

export const fetchWalkInVisitLogs = async (startDate, endDate) => {
  try {
    const response = await axios.get(`${WALK_IN_VISIT_URL}startDate=${startDate}&endDate=${endDate}`);
    return response.data;
  } catch (error) {
    throw new Error("Failed to fetch walk-in visit logs");
  }
};

export const fetchClassVisitLogs = async (startDate, endDate) => {
  try {
    const response = await axios.get(`${CLASS_VISIT_URL}startDate=${startDate}&endDate=${endDate}`);
    return response.data;
  } catch (error) {
    throw new Error("Failed to fetch class visit logs");
  }
};

